var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExternalArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 529,
    height: 484,
    viewBox: "0 0 529 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.075 229.148C284.723 228.641 284.345 228.181 283.919 227.749L154.035 97.7099C152.289 95.9672 150.021 95 147.67 95H-270.511C-274.458 95 -277.983 97.6975 -279.38 101.78C-280.785 105.856 -279.751 110.473 -276.801 113.359L-145.522 241.94L-276.801 370.523C-279.751 373.41 -280.785 378.027 -279.38 382.1C-277.986 386.184 -274.458 388.881 -270.511 388.881H147.67C150.021 388.881 152.289 387.916 154.035 386.174L283.919 256.131C284.345 255.702 284.723 255.24 285.075 254.736C290.308 247.201 290.308 236.682 285.075 229.148Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.703 229.314C249.416 228.906 249.106 228.533 248.755 228.184L142.221 122.88C140.79 121.469 138.93 120.686 137.002 120.686H-206.002C-209.239 120.686 -212.132 122.87 -213.276 126.178C-214.428 129.476 -213.579 133.215 -211.161 135.551L-103.484 239.675L-211.161 343.798C-213.579 346.135 -214.428 349.874 -213.276 353.172C-212.132 356.478 -209.239 358.662 -206.002 358.662H137.002C138.93 358.662 140.79 357.88 142.221 356.47L248.755 251.165C249.106 250.817 249.416 250.444 249.703 250.035C253.997 243.934 253.997 235.418 249.703 229.314Z",
    fill: "#B8A58A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.212 229.148C737.851 228.641 737.462 228.181 737.025 227.749L603.661 97.7099C601.869 95.9672 599.54 95 597.127 95H167.743C163.691 95 160.071 97.6975 158.637 101.78C157.194 105.856 158.255 110.473 161.284 113.359L296.08 241.94L161.284 370.523C158.255 373.41 157.194 378.027 158.637 382.1C160.068 386.184 163.691 388.881 167.743 388.881H597.127C599.54 388.881 601.869 387.916 603.661 386.174L737.025 256.131C737.462 255.702 737.851 255.24 738.212 254.736C743.586 247.201 743.586 236.682 738.212 229.148Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.893 229.314C701.598 228.906 701.279 228.533 700.919 228.184L591.531 122.88C590.062 121.469 588.153 120.686 586.172 120.686H233.98C230.657 120.686 227.686 122.87 226.511 126.178C225.329 129.476 226.2 133.215 228.683 135.551L339.245 239.675L228.683 343.798C226.2 346.135 225.329 349.874 226.511 353.172C227.686 356.478 230.657 358.662 233.98 358.662H586.172C588.153 358.662 590.062 357.88 591.531 356.47L700.919 251.165C701.279 250.817 701.598 250.444 701.893 250.035C706.302 243.934 706.302 235.418 701.893 229.314Z",
    fill: "#B8A58A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 529,
    height: 484,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExternalArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/external-arrow.d28f1273c83feb367806e2f4900db105.svg";